import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTextFree = SvgIcon({
    width: 48,
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M36.933 15.737h5.067v2.263h-7.437v-12h7.351v2.263h-4.981v2.554h4.551v2.229h-4.551v2.691z M27.826 15.737h5.067v2.263h-7.437v-12h7.351v2.263h-4.981v2.554h4.551v2.229h-4.551v2.691z M21.501 18l-2.422-4.166h-1.803v4.166h-2.37v-12h4.809c2.215 0 4.002 1.783 4.002 3.977 0 1.509-0.945 2.863-2.319 3.497l2.662 4.526h-2.559zM17.276 8.211v3.549h2.439c0.893 0 1.632-0.789 1.632-1.783s-0.738-1.766-1.632-1.766h-2.439z M13.179 8.263h-4.809v2.846h4.672v2.263h-4.672v4.629h-2.37v-12h7.179v2.263z" }),
});

export { IconTextFree };
